import { attr, customElement, GenesisElement } from '@genesislcap/web-core';
import { sinkingFundModalStyles as styles } from './sinking-fund-modal.styles';
import { sinkingFundModalTemplate as template } from './sinking-fund-modal.template';
import {
  parseSinkingFundSchedule,
  type SinkingFundScheduleEntry,
} from '../sinking-fund-schedule.util';

@customElement({
  name: 'sinking-fund-modal',
  template,
  styles,
})
export class SinkingFundModal extends GenesisElement {
  @attr({ mode: 'boolean' }) visible = false;

  @attr({ attribute: 'panel-style' }) panelStyle = '';

  @attr({ attribute: 'schedule-json' }) scheduleJson: string | null = null;

  get scheduleEntries(): SinkingFundScheduleEntry[] {
    return parseSinkingFundSchedule(this.scheduleJson);
  }

  handlePanelMouseEnter(): void {
    this.dispatchEvent(new CustomEvent('panel-mouseenter', { bubbles: true, composed: true }));
  }

  handlePanelMouseLeave(): void {
    this.dispatchEvent(new CustomEvent('panel-mouseleave', { bubbles: true, composed: true }));
  }
}
